import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/Auth/authSlice';
import globalReducer from '../features/Global/globalSlice';
import userInfoReducer from '../features/UserInfo/userInfoSlice'
import orgAuthReducer from '../features/Organization/OrgAuth/OrgAuthSlice';
import orgInfoReducer from '../features/Organization/OrganizationInfo/OrganizationInfoSlice'
import jobseekerReducer from '../features/Jobseeker/jobseekerSlice';
import JobReducer from '../features/Organization/Jobs/jobSlice';
import FilterSearchReducer from '../features/Global/FiltersSearchSlice';
import UserDataReducer from '../features/UserInfo/UserSlice';
import OrganizationReducer from '../features/Organization/OrganizationInfo/OrganizationSlice'
import { axiosInstance } from '../services/api';
import setupInterceptors from '../services/api/axiosSetup';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    global: globalReducer,
    userInfo: userInfoReducer,
    orgAuth: orgAuthReducer,
    orgInfo: orgInfoReducer,
    jobseeker: jobseekerReducer,
    jobs: JobReducer,
    filterSearch: FilterSearchReducer,
    userData: UserDataReducer,
    organizationData: OrganizationReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

setupInterceptors(axiosInstance, store); 